import React, { memo } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { LazyLoadImage } from "react-lazy-load-image-component";

const ItemRatingPoint = memo(({ className, itemRating, onSelected }) => {
  const { t } = useTranslation("translation");
  return (
    <div className={className}>
      <div onClick={onSelected} className={"variation-tab"}>
        <div className="flex items-center justify-center">
          <LazyLoadImage
            src={
              !itemRating?.isSelected
                ? itemRating?.["inactive-icon-url"]
                : itemRating?.["icon-url"]
            }
            className="rounded-md"
            style={{ width: 50, height: 50 }}
            alt="product image"
          />
        </div>
        <div
          className={
            itemRating.isSelected
              ? "font-700 fs-14 text-amount flex items-center justify-center text-name"
              : "font-500 fs-14 text-amount flex items-center justify-center text-name"
          }
        >
          {itemRating?.["name"]}
        </div>
      </div>
    </div>
  );
});

export default styled(ItemRatingPoint)`
  position: relative;
  .variation-tab {
    justify-content: center;
    display: relative;
    width: 100px;
    height: 76px;
  }
`;
